import React, { useState, useEffect, useMemo } from 'react';
import { TextField, Chip, Button as MUIButton, IconButton, InputAdornment, Button, TextareaAutosize } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import './Pages.css';
import SideBar from '../Components/Sidebar';
import { DateTimePicker, DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import {
    createPodcast,
    updatePodcast,
    getAIAgenda,
    getAIGuestInfo,
    deletePodcast
} from '../Services/SchedulesApi';
import ErrorModal from '../Components/ErrorModal';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useLoader } from '../Components/LoaderContext';
import deleteIcon from "../Assests/Delete.svg"
import aiIcon from "../Assests/AI Assist.svg"
import WarningDialog from '../Components/WarningDialog';
import MultiStageButton from '../Components/MultiStageButton';
import Inputbox from '../Components/Inputbox';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { FormControl, FormLabel } from '@mui/material';

const Schedule = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { podcast } = location.state || {};

    const parsedStartDate = podcast?.StartDttm ? dayjs(podcast.StartDttm) : null;
    const parsedEndDate = podcast?.EndDttm ? dayjs(podcast.EndDttm) : null;
    const HostMeetingToken = podcast?.HostMeetingToken;
    const [title, setTitle] = useState(podcast?.Title || "");
    const [startDate, setStartDate] = useState(parsedStartDate || dayjs());
    const [endDate, setEndDate] = useState(parsedEndDate || dayjs().add(1, 'hour'));
    const [guestEmails, setGuestEmails] = useState(podcast ? JSON.parse(podcast?.Guests) || [] : []);
    const [agenda, setAgenda] = useState(podcast?.Agenda || "");
    const [emailInput, setEmailInput] = useState("");
    const [guestInfo, setGuestInfo] = useState(podcast?.GuestInfo || []);
    const [importantLinks, setImportantLinks] = useState();
    const [quickLink, setQuickLink] = useState([]);
    const [popup, setPopup] = useState({ open: false, title: "", message: "" });
    const handlePopupClose = () => setPopup({ open: false, title: "", message: "" });
    const [loading, setLoading] = useState(false);
    const { triggerLoader, hideLoader } = useLoader();
    const [maxEndDate, setMaxEndDate] = useState();
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedScheduleId, setSelectedScheduleId] = useState(null);
    const [selectedPodcast, setSelectedPodcast] = useState(null);
    const [aiAgendaPrompt, setAiAgendaPrompt] = useState(false);
    const [aiGuestPrompt, setAiGuestPrompt] = useState(false);
    const [agendaContent, setAgendaContent] = useState("");
    const [guestContent, setGuestContent] = useState("");
    const [agendaStatus, setAgendaStatus] = useState('Generate');
    const [guestStatus, setGuestStatus] = useState('Generate');
    const [isAgendaAIActive, setIsAgendaAIActive] = useState(false);
    const [isGuestAIActive, setIsGuestAIActive] = useState(false);

    const customAgendaHandler = () => {
        setAiAgendaPrompt(prev => !prev)
        setIsAgendaAIActive(prev => !prev); 
    };

    const customGuestHandler = () => {
        setAiGuestPrompt(prev => !prev)
        setIsGuestAIActive(prev => !prev);
    }

    const agendaModules = useMemo(() => ({
        toolbar: {
            container: [
                [{ font: [] }],
                [{ size: ['small', 'medium', 'large', 'huge'] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ align: [] }],
                ['link'],
                ['clean'],
                [{ aiAgendaButton: 'AI' }],
            ],
            handlers: {
                aiAgendaButton: () => customAgendaHandler(),
            },
        },
    }), []);

    const guestInfoModules = useMemo(() => ({
        toolbar: {
            container: [
                [{ font: [] }],
                [{ size: ['small', 'medium', 'large', 'huge'] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ align: [] }],
                ['link'],
                ['clean'],
                [{ aiGuestInfoButton: 'AI' }],
            ],
            handlers: {
                aiGuestInfoButton: () => customGuestHandler(),
            },
        },
    }), []);

    useEffect(() => {
        const addCustomButton = (toolbarClass, buttonClass, iconSrc, isActive) => {
            const toolbar = document.querySelector(toolbarClass)
            if (!toolbar) return;
            toolbar.style.position = 'relative';
            toolbar.style.overflow = 'visible';
            const button = toolbar.querySelector(`button.ql-${buttonClass}`);
            if (button) {
                button.innerHTML = '';
                button.style.display = 'flex';
                button.style.alignItems = 'end';
                button.style.cursor = 'pointer';
                button.style.transition = 'all 0.2s ease';
                button.style.color = 'white';
                button.style.position = 'absolute';
                button.style.right = '0.5vh';
                button.style.width = '5vh';

                const divParent=document.createElement('div');
                divParent.classList.add("ai-icon-divParent-gradient");
                const img = document.createElement('img');
                img.src = iconSrc;
                img.alt = 'AI Icon';
                img.style.width = '2.2vh';
                img.style.height = '2.2vh';
                img.style.position = 'relative';
                img.style.top = '0';
                img.style.left = '0';

                const divChild=document.createElement('div');
                divChild.classList.add("ai-icon-gradient");
                divParent.appendChild(img);
                divParent.appendChild(divChild);

                const span = document.createElement('span');
                span.textContent = 'AI';
                span.style.fontSize = '1.6vh';
                span.style.color = 'white';
                span.style.fontWeight = '500';
                span.style.position = 'relative';
                span.style.top = '0.3vh';

                button.innerHTML = '';
                button.appendChild(divParent);
                button.appendChild(span);
                
                if (isActive) {
                    button.classList.add('active');
                    button.style.borderRadius = '0.8vh';
                    button.style.background = 'rgba(71, 45, 219, 0.50)';
                    button.style.padding = '0.4vh 0.4vh 0.4vh 0.4vh';
                } else {
                    button.classList.remove('active');
                    button.style.background = 'transparent';
                    button.style.borderRadius = '0';
                    button.style.padding = '0.8vh 0.8vh 0.8vh 0.4vh';
                }
            }
        };

        addCustomButton('.agenda-editor .ql-toolbar', 'aiAgendaButton', aiIcon , isAgendaAIActive);
        addCustomButton('.guest-info-editor .ql-toolbar', 'aiGuestInfoButton', aiIcon , isGuestAIActive);

    }, [aiIcon, isAgendaAIActive, isGuestAIActive]);

    useEffect(() => {
        if (podcast?.ImportantLinks) {
            const array = podcast?.ImportantLinks
                .split(",")
                .map(link => link.trim())
                .filter(link => !!link);
            setQuickLink(array);
        }
    }, []);


    const handleAddGuestEmail = () => {
        if (emailInput.trim()) {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailRegex.test(emailInput)) {
                setPopup({
                    open: true,
                    title: "Invalid Email",
                    message: "Please enter a valid email address.",
                });
                return;
            }

            if (guestEmails.includes(emailInput.trim())) {
                setPopup({
                    open: true,
                    title: "Duplicate Email",
                    message: "This email is already added to the guest list.",
                });
                return;
            }

            setGuestEmails([...guestEmails, emailInput.trim()]);
            setEmailInput("");
        }
    };

    const handleStartDateChange = (newDate) => {
        setStartDate(newDate);
        setEndDate(newDate.add(1, 'hour'));
        setMaxEndDate(startDate ? dayjs(newDate).add(7, 'day') : null)
    };

    const handleEndDateChange = (newDate) => {
        setEndDate(newDate);
    }

    const handleSave = async () => {
        if (!title.trim() || !startDate || !endDate) {
            setPopup({
                open: true,
                title: "Missing Information",
                message: "Please fill in the Title, Start Date, and End Date to continue. Thank you!",
            });
            return;
        }
        if (loading) return;
        setLoading(true);

        const data = {
            UserID: localStorage.getItem('user_id'),
            ScheduleID: podcast?.ScheduleID || `schedule-${Date.now()}`,
            Title: title,
            StartDttm: dayjs(startDate).set('second', 0),
            EndDttm: dayjs(endDate).set('second', 0),
            Guests: guestEmails,
            Agenda: agenda,
            GuestInfo: guestInfo,
            ImportantLinks: quickLink.join(','),
        };

        try {
            if (podcast) {
                triggerLoader("Updating scheduled podcast...");
                console.log("Updating podcast with data:", data);
                await updatePodcast(data);
            } else {
                triggerLoader("Scheduling podcast...");
                console.log("Creating new podcast with data:", data);
                await createPodcast(data);
            }
            hideLoader();
            navigate("/shows");
        } catch (error) {
            console.error("Error saving data:", error);
            setPopup({
                open: true,
                title: "Error",
                message: "An error occurred while saving. Please try again.",
            });
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteGuestEmail = (emailToDelete) => {
        setGuestEmails(guestEmails.filter(email => email !== emailToDelete));
    };


    const handleAddImpLinks = () => {
        if (!importantLinks || typeof importantLinks !== 'string') return;
        const trimmedLink = importantLinks.trim();

        if (!trimmedLink) {
            setPopup({
                open: true,
                title: "Empty Link",
                message: "Please enter a link before adding.",
            });
            return;
        }

        try {
            const url = new URL(trimmedLink);

            if (url.protocol !== 'http:' && url.protocol !== 'https:') {
                throw new Error("Invalid protocol");
            }

            if (quickLink.includes(trimmedLink)) {
                setPopup({
                    open: true,
                    title: "Duplicate Link",
                    message: "This link is already added to the Quick Links list.",
                });
                return;
            }

            setQuickLink([...quickLink, trimmedLink]);
            setImportantLinks("");

        } catch (error) {
            console.error("Invalid URL format:", error.message);
            setPopup({
                open: true,
                title: "Invalid Link",
                message: "Please enter a valid URL (Eg: https://example.com)",
            });
        }
    };


    const handleDeleteImpLink = (linkToDelete) => {
        setQuickLink(quickLink.filter(link => link !== linkToDelete));
    };

    const handleJoinStudio = () => {
        if (podcast.guest) {
            console.log("using Guest stage")
            navigate(`/meeting?meetingId=${podcast.MeetingID}&showName=${title}&guest=${podcast.guest ? "true" : "false"}&token=${HostMeetingToken}`);
        } else {
            console.log("using Host stage")
            navigate(`/meeting?meetingId=${podcast.MeetingID}&showName=${title}&token=${HostMeetingToken}`);
        }
    }

    const handleDeletePodcast = () => {
        setSelectedScheduleId(podcast?.ScheduleID);
        setSelectedPodcast(podcast);
        setOpenDialog(true);
    };

    const confirmDelete = async () => {
        setOpenDialog(false);
        triggerLoader("Deleting Podcast...");
        if (selectedScheduleId) {
            try {
                await deletePodcast(selectedScheduleId);

            } catch (error) {
                console.error("Error deleting podcast:", error);
            } finally {
                hideLoader();
                navigate("/shows")
            }
        }
    };

    const handleDialogClose = () => {
        setOpenDialog(false);
        setSelectedScheduleId(null);
        setSelectedPodcast(null);
    };

    const handleFetchAgenda = async () => {
        try {
            setAgendaStatus('Creating');
            const { data } = await getAIAgenda(agendaContent);
            const aiAgenda = data?.Data?.trim?.() || '';
            if (aiAgenda) {
                setAgendaStatus('Accept');
                setAgenda(prev => `${prev}\n\n${aiAgenda}`);
            } else {
                setAgendaStatus('Generate');
            }
        } catch (error) {
            console.error('Failed to generate agenda:', error);
            setAgendaStatus('Generate');
            return;
        }
    }

    const handleFetchGuestInfo = async () => {

        setGuestStatus('Creating')
        let result;
        try {
            result = await getAIGuestInfo(guestContent);
            const Data = result?.data?.Data || '';

            if (Data) {
                setGuestStatus('Accept');
                setGuestInfo(prev => `${prev}\n\n${Data}`);
            } else {
                setGuestStatus('Generate');
            }
        } catch (error) {
            console.error("Error fetching AI Guest Info:", error);
            setGuestStatus('Generate');
            return;
        }
    }

    const handleClick = async () => {
        if (agendaStatus == 'Generate' && agendaContent) {
            await handleFetchAgenda();
        } else if (agendaStatus == 'Accept') {
            // setAgendaStatus('Generate');
            setAiAgendaPrompt(false)
        }
    };

    const handleRegenerateAgenda = async () => {
        setAgenda("")
        await handleFetchAgenda();
    };

    const handleGuestInfoGenerate = async () => {
        if (guestStatus == 'Generate' && guestContent) {
            await handleFetchGuestInfo();
        } else if (guestStatus == 'Accept') {
            setAiGuestPrompt(false)
            setIsGuestAIActive(false);
            // setGuestStatus('Generate');

        }
    }

    const handleRegenerateGuestInfo = async () => {
        setGuestInfo("")
        await handleFetchGuestInfo();
    }

    const handleRejectAgenda = () => {
        setAgenda("")
        setAgendaStatus('Generate')
        setAiAgendaPrompt(false);
        setIsAgendaAIActive(false);
    }

    const handleRejectGuest = () => {
        setGuestInfo("")
        setGuestStatus('Generate')
        setAiGuestPrompt(false);
        setIsGuestAIActive(false);
    }

    const datePickerStyle = {
        "& .MuiInputBase-input": {
            color: '#fff',
            fontSize: '1.6vh',
            letterSpacing: '0.024vh',
            padding: '0.8vh 1.6vh'
        },
        "& .MuiSvgIcon-root": {
            color: 'white',
            fontSize: '2.4vh'
        },
        "& .MuiFormLabel-root": {
            color: 'white !important'
        },
        "& .MuiOutlinedInput-root": {
            borderRadius: '1.2vh',
            height: '6vh',
            "& fieldset": {
                borderColor: "white",
                borderRadius: "1.2vh",
            },
            "&:hover fieldset": {
                borderColor: "white",
            },
        },
        "& .Mui-focused": {
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "white !important",
            },
            "& .MuiFormLabel-root": {
                color: "white !important",
            },
        },
        "& .MuiPickersPopper-root": {
            "& .MuiPaper-root": {
                fontSize: '1.4vh',
                "& .MuiTypography-root": {
                    fontSize: '1.4vh'
                },
                "& .MuiButton-root": {
                    fontSize: '1.2vh'
                },
                "& .MuiPickersDay-root": {
                    fontSize: '1.2vh',
                    width: '3.2vh',
                    height: '3.2vh'
                }
            }
        },
        borderRadius: "1.2vh",
        width: "100%",
    };

    const testDate = () => {
        return new Date(parsedStartDate) >= new Date()
    }

    const goBack = () => {
        navigate(-1)
    }

    return (
        <div className='theme-bg clr-white height-100 schedule-main-container'>
            <SideBar></SideBar>
            <div className='schedule-content-wrapper'>
                <div className='schedule-header-container'>
                    <div className="schedule-podcast-header-title">
                        <button className="schedule-podcast-left-arrow" onClick={goBack}>
                            <ArrowBackIosIcon />
                        </button>
                        <span>Schedule for Upcoming Podcast Episode</span>
                    </div>
                </div>
                <div className="schedule-form-wrapper">
                    <div className="schedule-form-content">
                        <div className="schedule-form-fields">
                                    <div className="schedule-form-row">
                                        <div className="schedule-form-field">
                                            <FormControl fullWidth>
                                                <FormLabel sx={{ color: '#FFFFFF', fontSize: '1.4vh', fontWeight:'100',marginLeft: '1.2vh', letterSpacing: '0.024vh' }}>
                                                    Title
                                                </FormLabel>
                                                <TextField
                                                    placeholder="Enter title"
                                                    value={title}
                                                    onChange={(e) => setTitle(e.target.value)}
                                                    sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: '1.2vh',
                                                        height: '6vh',
                                                        '& fieldset': {
                                                        borderColor: '#FFFFFF',
                                                        },
                                                        '&:hover fieldset': {
                                                        borderColor: '#FFFFFF',
                                                        },
                                                        '&.Mui-focused fieldset': {
                                                        borderColor: '#FFFFFF',
                                                        },
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '1.6vh !important',
                                                        letterSpacing: '0.024vh !important',
                                                        padding: '0.8vh 1.6vh !important',
                                                        color: '#fff !important',
                                                        '&::placeholder': {
                                                            fontSize: '1.6vh !important',
                                                            color: 'rgba(255, 255, 255, 0.7) !important',
                                                            opacity: '1 !important'
                                                        }
                                                    }
                                                    }}
                                                />
                                            </FormControl>
                                        </div>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <div className="schedule-form-field">
                                                <FormControl fullWidth variant="filled">
                                                <FormLabel sx={{ color: '#FFFFFF', fontSize: '1.4vh', fontWeight:'100',marginLeft: '1.2vh', letterSpacing: '0.024vh'}}>
                                                    Start Date and Time
                                                </FormLabel>
                                                <DateTimePicker
                                                    value={startDate}
                                                    minDateTime={dayjs().subtract(5, 'minute')}
                                                    onChange={handleStartDateChange}
                                                    sx={datePickerStyle}
                                                    disabled={podcast?.guest}
                                                />
                                                </FormControl>
                                            </div>
                                            <div className="schedule-form-field">
                                                <FormControl fullWidth variant="filled">
                                                <FormLabel sx={{color: '#FFFFFF', fontSize: '1.4vh', fontWeight:'100',marginLeft: '1.2vh', letterSpacing: '0.024vh' }}>
                                                    End Date and Time
                                                </FormLabel>
                                                <DateTimePicker
                                                    value={endDate}
                                                    minDateTime={startDate}
                                                    maxDateTime={maxEndDate}
                                                    onChange={handleEndDateChange}
                                                    sx={datePickerStyle}
                                                    disabled={podcast?.guest}
                                                />
                                                </FormControl>
                                            </div>
                                        </LocalizationProvider>
                                    </div>
                                    <div className="schedule-form-section">
                                        <div className="schedule-form-field-row">
                                            <FormControl fullWidth>
                                                <FormLabel sx={{ color: '#FFFFFF', fontSize: '1.4vh', fontWeight:'100',marginLeft: '1.2vh', letterSpacing: '0.024vh' }}>
                                                    Guest Email
                                                </FormLabel>
                                                <TextField
                                                    placeholder="Enter guest emails.."
                                                    value={emailInput}
                                                    type="email"
                                                    onChange={(e) => setEmailInput(e.target.value)}
                                                    sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '1.2vh',
                                                    height: '6vh',
                                                    '& fieldset': {
                                                    borderColor: '#FFFFFF',
                                                    },
                                                    '&:hover fieldset': {
                                                    borderColor: '#FFFFFF',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                    borderColor: '#FFFFFF',
                                                    },
                                                },
                                                '& .MuiInputBase-input': {
                                                    fontSize: '1.6vh',
                                                    letterSpacing: '0.024vh',
                                                    padding: '0.8vh 1.6vh',
                                                    color: '#fff'
                                                },
                                                '& .MuiInputBase-input::placeholder': {
                                                    fontSize: '1.6vh',
                                                    color: 'rgba(255, 255, 255, 0.7)',
                                                    opacity: 1
                                                }
                                                }}
                                                    onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleAddGuestEmail();
                                                    }
                                                    }}
                                                    InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                        <IconButton onClick={handleAddGuestEmail} disabled={podcast?.guest}>
                                                            <AddIcon sx={{ color: 'white', fontSize: '2.5vh' }} />
                                                        </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                    }}
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="schedule-chips-container">
                                            {guestEmails.map((email, index) => (
                                                <Chip
                                                    key={index}
                                                    label={email}
                                                    color="primary"
                                                    variant="filled"
                                                    onDelete={() => handleDeleteGuestEmail(email)}
                                                    sx={{ bgcolor: 'rgba(255, 255, 255, 0.1)' }}
                                                    disabled={podcast?.guest}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                    <div className="schedule-form-section">
                                        <div className="schedule-form-label">
                                            <span>Agenda</span>
                                        </div>
                                        <div className='agenda-editor'>
                                            <ReactQuill
                                                value={agenda}
                                                onChange={setAgenda}
                                                modules={agendaModules}
                                                placeholder="Enter agenda details here"
                                                className={`quill-editor-container ${agendaStatus === 'Accept' ? 'gradient-text' : ''}`}
                                                readOnly={podcast?.guest}
                                            />
                                            {
                                                aiAgendaPrompt && (
                                                    <div className="custom-prompt-container">
                                                        <input
                                                            type="text"
                                                            className="custom-prompt-input"
                                                            placeholder="Provide your podcast content, I will assist you in generating a structured agenda..."
                                                            value={agendaContent}
                                                            onChange={(e) => setAgendaContent(e.target.value)}
                                                            disabled={podcast?.guest}
                                                        />
                                                        <div className="end-adornment">
                                                            <MultiStageButton
                                                                initialStatus={agendaStatus}
                                                                handleClick={handleClick}
                                                                handleReject={handleRejectAgenda}
                                                                handleReload={handleRegenerateAgenda}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="schedule-form-section">
                                        <div className="schedule-form-label">
                                            <span>Guest Details</span>
                                        </div>
                                        <div className='guest-info-editor'>
                                            <ReactQuill
                                                value={guestInfo}
                                                onChange={setGuestInfo}
                                                modules={guestInfoModules}
                                                placeholder="Enter guest details here"
                                                className={`quill-editor-container ${guestStatus === 'Accept' ? 'gradient-text' : ''}`}
                                                readOnly={podcast?.guest}
                                            />
                                            {
                                                aiGuestPrompt && (
                                                    <div className="custom-prompt-container">
                                                        <input
                                                            type="text"
                                                            className="custom-prompt-input"
                                                            placeholder="Share the guest summary here,I’ll help you to prepare a professional guest overview..."
                                                            value={guestContent}
                                                            onChange={(e) => setGuestContent(e.target.value)}
                                                            disabled={podcast?.guest}
                                                        />
                                                        <div className="end-adornment">
                                                            <MultiStageButton
                                                                initialStatus={guestStatus}
                                                                handleClick={handleGuestInfoGenerate}
                                                                handleReject={handleRejectGuest}
                                                                handleReload={handleRegenerateGuestInfo}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="schedule-form-section">
                                        <div className="schedule-form-field-row">
                                            <FormControl fullWidth>
                                                <FormLabel sx={{ color: '#FFFFFF', fontSize: '1.4vh', fontWeight:'100',marginLeft: '1.2vh', letterSpacing: '0.024vh'}}>
                                                    Important Links
                                                </FormLabel>
                                                <TextField
                                                    placeholder="Enter any important links here"
                                                    value={importantLinks}
                                                    onChange={(e) => setImportantLinks(e.target.value)}
                                                    onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleAddImpLinks();
                                                    }
                                                    }}
                                                    InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                        <IconButton onClick={handleAddImpLinks} disabled={podcast?.guest}>
                                                            <AddIcon sx={{ color: 'white', fontSize: '2.5vh' }} />
                                                        </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                    }}
                                                    sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '1.2vh',
                                                    height: '6vh',
                                                    '& fieldset': {
                                                    borderColor: '#FFFFFF',
                                                    },
                                                    '&:hover fieldset': {
                                                    borderColor: '#FFFFFF',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                    borderColor: '#FFFFFF',
                                                    },
                                                },
                                                '& .MuiInputBase-input': {
                                                    fontSize: '1.6vh',
                                                    letterSpacing: '0.024vh',
                                                    padding: '0.8vh 1.6vh',
                                                    color: '#fff'
                                                },
                                                '& .MuiInputBase-input::placeholder': {
                                                    fontSize: '1.6vh',
                                                    color: 'rgba(255, 255, 255, 0.7)',
                                                    opacity: 1
                                                }
                                                }}
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="schedule-chips-container">
                                            {quickLink?.map((link, index) => (
                                                <Chip
                                                    key={link}
                                                    label={link}
                                                    color="primary"
                                                    variant="filled"
                                                    onDelete={() => handleDeleteImpLink(link)}
                                                    sx={{ bgcolor: 'rgba(255, 255, 255, 0.1)' }}
                                                    disabled={podcast?.guest}
                                                />
                                            ))}
                                        </div>
                                    </div>
                        </div>
                    </div>
                    <div className="schedule-form-actions-container">
                                    <div className="schedule-form-actions">
                                        <div className="schedule-form-delete-btn">
                                            {podcast && !podcast?.guest && (
                                                <button onClick={handleDeletePodcast}>
                                                    <span className="text-trans-none">Delete Podcast</span>
                                                    <img className="schedule-icon" src={deleteIcon} />
                                                </button>
                                            )}
                                        </div>
                                        <div className="schedule-form-save-btns">
                                            {podcast && testDate() && (
                                                <button onClick={handleJoinStudio}>
                                                    <span className='text-trans-none'>Join Studio</span>
                                                </button>
                                            )}

                                            {!loading && !podcast?.guest && (
                                                <button onClick={handleSave}>
                                                    <span className='text-trans-none'>Save and Send</span>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                    </div>
                </div>
            </div>
            <ErrorModal open={popup.open} onClose={handlePopupClose} title={popup.title} message={popup.message} />
            <WarningDialog
                open={openDialog}
                onClose={handleDialogClose}
                onConfirm={confirmDelete}
                title="Delete Schedule"
                description={
                    selectedPodcast?.Title
                        ? `Are you sure you want to delete this schedule: ${selectedPodcast.Title}?`
                        : "Are you sure you want to delete this schedule?"
                }
            />
        </div>
    );
}

export default Schedule;